export const createNewProgramModel = () => ({
    institutionId: null,
    programName: '',
    cipCode: null,
    locations: [],
    degreeLevel: null,
    deliveryMode: null,
    onlineNature: null,
    creditMin: '',
    creditMax: '',
    comments: '',
});

export const createNewProgramEditModel = details => ({
    institutionId: details?.institutionId ?? null,
    programName: details?.programName ?? '',
    cipCode: details?.cipCode ?? null,
    locations: (details?.locations ?? []).map(location => ({
        value: location.locationId,
        label: location.locationName ?? location.locationId,
        statusId: Number(location.statusId ?? 1),
    })),
    degreeLevel: details?.degreeLevelId ?? null,
    deliveryMode:
        details?.deliveryMode === 'On Campus and Online' ? 3 :
            details?.deliveryMode === 'On Campus Only' ? 1 :
                details?.deliveryMode === 'Online Only' ? 2 : null,
    onlineNature:
        details?.deliveryModeOnline === '100% Online' ? 1 :
            details?.deliveryModeOnline === 'Blended' ? 2 : 0,
    creditMin: details?.creditRequirementMinimum ?? '',
    creditMax: details?.creditRequirementMaximum ?? '',
    comments: '',
});

export const toNewProgramRequest = form => ({
    institutionId: form.institutionId,
    formalName: form.programName.trim(),
    cipCode: form.cipCode,
    degreeLevel: form.degreeLevel,
    distanceEdApproved: { id: form.deliveryMode },
    distanceEdOnline: { id: form.onlineNature ?? 0 },
    creditRequirementMinimum:
        form.creditMin !== '' ? Number(form.creditMin) : null,
    creditRequirementMaximum:
        form.creditMax !== '' ? Number(form.creditMax) : null,
    locationStatusChanges: form.locations.map(location => ({
        locationId: location.value,
        statusId: 1,
    })),
    comments: form.comments || null,
});

export const toEditNewProgramRequest = (form, details) => ({
    ...toNewProgramRequest(form),
    requestId: details?.requestID ?? details?.requestId,
});
